interface ICommandAttributesOptions {
  description: string;
  keywords: string;
  label: string;
}

export function createCommandAttributes({
  description,
  keywords,
  label,
}: ICommandAttributesOptions): {
  'data-command': 'true';
  'data-command-description': string;
  'data-command-keywords': string;
  'data-command-label': string;
} {
  return {
    'data-command': 'true' as const,
    'data-command-description': description,
    'data-command-keywords': keywords,
    'data-command-label': label,
  };
}
